import { HTTP_TOKEN } from "./http";

export const getVersionBack = () => {
    return HTTP_TOKEN.get("version").then(result => {
      return result.data;
    });
  };
